<template>
    <div class="component-container">
        <div class="chart-canvas" ref="amount"></div>
        <img class="banner" src="@/assets/images/bg-pic.png" alt="" />
    </div>
</template>

<script>
import * as echarts from "echarts";

import { mapState } from "vuex";
export default {
    data () {
        return {
            scatterData: [], //散点图数据
            dateList: [], //日期列表
            startVal: 0, //区域缩放的起点值
            endVal: 5, //区域缩放的起点值
            timeId: null, //定时器的id

            myChart: undefined,
            sort: 1,
            sortTitle: '过磅毛重排名',
            tooltipTitle: '过磅毛重',
            xData: [],
            yData: []
        };
    },
    async mounted () {
        setInterval(() => {
            this.sort++
            if (this.sort == 5) {
                this.sort = 1
            }
            this.initChart();
        }, 5000)
        this.initChart();
    },
    computed: {
        ...mapState(["dateType"]),
    },
    watch: {
        dateType (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.getData();
            }
        },
    },
    destroyed () {
        clearInterval(this.timeId);
    },
    methods: {
        // 初始化表
        async initChart () {
            const chartDom = this.$refs.amount;
            this.myChart = echarts.init(chartDom);
            await this.getData();
            this.startInterval();
            this.myChart.on("mouseover", () => {
                clearInterval(this.timeId);
            });
            this.myChart.on("mouseout", () => {
                this.startInterval();
            });
        },
        //获取后台的数据
        async getData () {

            await this.$http
                .get("/screen/merchantCensusList?type=" + this.dateType + '&sort=' + this.sort, {})
                .then((response) => {
                    if (response.data.resultCode === 200) {
                        // this.scatterData = [];
                        // this.dateList = [];
                        this.xData = []
                        this.yData = []
                        const allDataList = response.data.inList;
                        allDataList.forEach((item, index) => {
                            // this.scatterData.push(item.total_amount);
                            // this.dateList.push(item.time);
                            this.xData.push(item.customerName)
                            if (this.sort == 1) {   //  过磅毛重排名
                                this.yData.push(item.totalWeight)
                                this.sortTitle = '过磅毛重排名'
                            } else if (this.sort == 2) {   //  过磅总收费排名
                                this.yData.push(item.inAmtActual)
                                this.sortTitle = '过磅总收费排名'
                            } else if (this.sort == 3) {  //  过磅净重排名
                                this.yData.push(item.weight)
                                this.sortTitle = '过磅净重排名'
                            } else if (this.sort == 4) {   //  过磅净收费排名
                                this.yData.push(item.payAmtActual)
                                this.sortTitle = '过磅净收费排名'
                            }

                        });

                        this.xData = this.xData.reverse()
                        this.yData = this.yData.reverse()
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            this.startVal = 0;
            this.endVal = 5;
            this.showEcharts();
        },
        //展示图表
        showEcharts () {
            var myColor = ['#eb2100', '#eb3600', '#d0570e', '#d0a00e', '#34da62', '#00e9db', '#00c0e9', '#0096f3', '#33CCFF', '#33FFCC'];
            const option = {
                title: {
                    text: this.sortTitle,
                    left: "17",
                    top: "6",
                    textStyle: {
                        color: "#00C4FF",
                    },
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: function (params) {
                        return params[0].name + "<br/>" + params[0].data;
                    }
                },
                // legend: {},
                // xAxis: {
                //     // show: true,
                //     // type: "category",
                //     // name: "日期",
                //     // nameTextStyle: {},
                //     // data: this.dateList,
                //     // axisLabel: {
                //     //     show: true,
                //     //     textStyle: {
                //     //         color: "#fff",
                //     //         fontSize: 16,
                //     //     },
                //     // },
                //     // axisTick: {
                //     //     show: false,
                //     // },
                //     // nameTextStyle: {
                //     //     color: "#0CFEEE",
                //     //     fontSize: 18,
                //     // },
                //     type: 'value',
                //     boundaryGap: [1, 0.1]
                // },
                // yAxis: {
                //     // type: "value",
                //     // show: true,
                //     // name: "金额(万元)",
                //     // splitLine: false,
                //     // axisLabel: {
                //     //     show: true,
                //     //     textStyle: {
                //     //         color: "#fff", //y轴的刻度线颜色
                //     //         fontSize: 17,
                //     //     },
                //     // },
                //     // nameTextStyle: {
                //     //     color: "#0CFEEE", //坐标轴name颜色
                //     //     fontSize: 16,
                //     // },
                //     type: 'category',
                //     data: ['Brazil', 'Indonesia', 'USA', 'India', 'China', 'World']
                // },
                // // dataZoom: {
                // //     show: false,
                // //     startValue: this.startVal,
                // //     endValue: this.endVal,
                // // },
                // grid: {
                //     // left: "12%",
                //     // right: "12%",
                //     // bottom: "12%",
                //     // top: "28%",
                //     left: '3%',
                //     right: '4%',
                //     bottom: '3%',
                //     containLabel: true
                // },
                // series: [
                //     {
                //         name: '2011',
                //         type: 'bar',
                //         data: [18203, 23489, 29034, 104970, 131744, 630230]
                //     },
                //     {
                //         name: '2012',
                //         type: 'bar',
                //         data: [19325, 23438, 31000, 121594, 134141, 681807]
                //     }
                // ]
                // series: [
                //     {
                //         data: this.scatterData,
                //         type: "scatter",
                //         symbolSize: 14,
                //         label: {
                //             show: true,
                //             position: "top",
                //             fontSize: 18,
                //             color: "#fff",
                //         },
                //         itemStyle: {
                //             color: "#0DC8D4",
                //         },
                //     },
                // ],
                grid: {
                    left: '11%',
                    top: '18%',
                    right: '3%',
                    bottom: '0%',
                    containLabel: true
                },
                xAxis: [{
                    show: false,
                }],
                yAxis: [
                    {
                        axisTick: 'none',
                        axisLine: 'none',
                        offset: '27',
                        axisLabel: {
                            textStyle: {
                                color: '#ffffff',
                                fontSize: '16',
                            }
                        },
                        data: this.xData
                    },
                    {
                        axisTick: 'none',
                        axisLine: 'none',
                        axisLabel: {
                            textStyle: {
                                color: '#ffffff',
                                fontSize: '16',
                            }
                        },
                        data: ['10', '9', '8', '7', '6', '5', '4', '3', '2', '1']
                    },
                    {
                        name: '',
                        nameGap: '50',
                        nameTextStyle: {
                            color: '#ffffff',
                            fontSize: '16',
                        },
                        axisLine: {
                            lineStyle: {
                                color: 'rgba(0,0,0,0)'
                            }
                        },
                        data: [],
                    }
                ],
                series: [
                    {
                        name: '条',
                        type: 'bar',
                        yAxisIndex: 0,
                        data: this.yData,
                        label: {
                            normal: {
                                show: true,
                                position: 'center',
                                textStyle: {
                                    color: '#fff',
                                    fontSize: '16',
                                }
                            }
                        },
                        barWidth: 16,
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    var num = myColor.length;
                                    return myColor[params.dataIndex % num]
                                },
                            }
                        },
                        z: 2
                    },
                    {
                        name: '白框',
                        type: 'bar',
                        yAxisIndex: 1,
                        barGap: '-100%',
                        data: [99, 99.5, 99.5, 99.5, 99.5, 99.5, 99.5, 99.5, 99.5, 99.5],
                        barWidth: 20,
                        itemStyle: {
                            normal: {
                                color: '#0e2147',
                                barBorderRadius: 5,
                            }
                        },
                        z: 1
                    },
                    // {
                    //     name: '外框',
                    //     type: 'bar',
                    //     yAxisIndex: 2,
                    //     barGap: '-100%',
                    //     data: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
                    //     barWidth: 24,
                    //     itemStyle: {
                    //         normal: {
                    //             color: function (params) {
                    //                 var num = myColor.length;
                    //                 return myColor[params.dataIndex % num]
                    //             },
                    //             barBorderRadius: 5,
                    //         }
                    //     },
                    //     z: 0
                    // },
                    // {
                    //     name: '外圆',
                    //     type: 'scatter',
                    //     hoverAnimation: false,
                    //     data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    //     yAxisIndex: 2,
                    //     symbolSize: 35,
                    //     itemStyle: {
                    //         normal: {
                    //             color: function (params) {
                    //                 var num = myColor.length;
                    //                 return myColor[params.dataIndex % num]
                    //             },
                    //             opacity: 1,
                    //         }
                    //     },
                    //     z: 2
                    // }
                ]
            };
            option &&
                this.myChart.setOption(option);
            this.myChart.resize()
        },
        startInterval () {
            // 判断定时器是否存在
            if (this.timeId) {
                clearInterval(this.timeId);
            }
            this.timeId = setInterval(() => {
                this.startVal++;
                this.endVal++;
                if (this.endVal > this.scatterData.length - 1) {
                    this.startVal = 0;
                    this.endVal = 5;
                }
                this.showEcharts();
            }, 2000);
        },
    },
};
</script>
<style scoped>
#main {
    width: 100%;
    height: 270px;
    background-image: url(@/assets/images/bg.png);
    background-repeat: round;
    position: relative;
    z-index: 5555;
}
.banner {
    position: absolute;
    top: 15px;
    left: 28px;
    z-index: -10;
}
</style>
